class Adsense {
    constructor() {
    }

    domInjection() {
        let newScriptElement = document.createElement("script");

        newScriptElement.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        newScriptElement.type = 'text/javascript';
        newScriptElement.async = true;
        newScriptElement.setAttribute("data-ad-client", "REPLACE_CLIENT_DATA_AD");

        this.appendElementToBody(newScriptElement);
    }

    appendElementToBody(element) {
        let bodyElem = document.getElementsByTagName("body")[0];

        bodyElem.append(element);
    }
}

export default Adsense;